import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Alert,
  Typography,
  AlertTitle,
} from "@mui/material";
import { Amount, Chunk } from "@/contexts/DealContext";
import ExpandableAlert from "../review/ExpandableAlert";

type AmountInputProps = {
  value: Amount;
  onChange: (updatedValue: Amount) => void;
};

const AmountInput: React.FC<AmountInputProps> = ({ value, onChange }) => {
  return (
    <>
      <ExpandableAlert
        title={
          (value.amount.chunk &&
            "metadata" in value.amount.chunk &&
            value.amount.chunk?.metadata?.title) ||
          "title"
        }
        chunk={value.amount.chunk as Chunk}
      ></ExpandableAlert>
      {/* <Alert sx={{ mb: 2 }}>
        <AlertTitle>
          {(value.amount.chunk &&
            "metadata" in value.amount.chunk &&
            value.amount.chunk?.metadata?.section_title) ||
            "title"}
        </AlertTitle>
        <Typography variant="body2">{value.amount.chunk?.page_content}</Typography>
      </Alert> */}
      <Box display="flex" gap={2}>
        <TextField
          label="Amount"
          variant="outlined"
          fullWidth
          value={
            value.amount.value
              ? Number(value.amount.value.replaceAll(",", "")).toLocaleString("fi-FI", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })
              : ""
          }
          onChange={(e) => {
            const rawValue = e.target.value.replace(/\s/g, "").replaceAll(",", ".");
            console.log("rawValue", rawValue);
            console.log("Number(rawValue)", Number(rawValue));
            if (!isNaN(Number(rawValue))) {
              onChange({
                ...value,
                amount: { ...value.amount, value: rawValue, validated: true},
              });
            }
          }}
        />

        <FormControl variant="outlined" sx={{ minWidth: 120 }}>
          <InputLabel>Currency</InputLabel>
          <Select
            value={value.currency?.value || "EUR"}
            onChange={(e) =>
              onChange({
                ...value,
                currency: { ...value.currency, value: e.target.value },
              })
            }
            label="Currency"
          >
            <MenuItem value="EUR">EUR</MenuItem>
            <MenuItem value="USD">USD</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export default AmountInput;
